var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBadFeedback = function SvgBadFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M482 211h-91v60c0 33.091-26.909 60-60 60h-90v30c0 16.538 13.462 30 30 30h120v60l60-60h31c16.538 0 30-13.462 30-30V241c0-16.538-13.462-30-30-30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 301h61l60 60v-60h180c16.538 0 30-13.462 30-30V91c0-16.538-13.462-30-30-30H30C13.462 61 0 74.462 0 91v180c0 16.538 13.462 30 30 30m196-195h90v30h-90zm0 60h90v30h-90zm0 60h90v30h-90zM65.395 146.605l21.211-21.211L121 159.789l34.395-34.395 21.211 21.211L142.211 181l34.395 34.395-21.211 21.211L121 202.211l-34.395 34.395-21.211-21.211L99.789 181z"
  })));
};
export default SvgBadFeedback;